import React, { useContext } from 'react';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { AppStateContext } from '../AppStateContext';

import { translations } from '../data/treatment'
import { useNavigate } from 'react-router-dom';

// IMPORT IMAGES
import treatment1 from '../media/treatment-1.png'
import treatment2 from '../media/treatment-2.png'
import treatment3 from '../media/treatment-3.png'
import treatment4 from '../media/treatment-4.png'
import treatment5 from '../media/treatment-5.png'
import treatment6 from '../media/treatment-6.png'
import treatment7 from '../media/treatment-7.png'
import treatment8 from '../media/treatment-8.png'
import treatment9 from '../media/treatment-9.png'
import treatment10 from '../media/treatment-10.png'
import treatment11 from '../media/treatments/zirconium-2.webp'
import treatment12 from '../media/treatment-11.webp'



const LogoSlider = () => {

    const navigate = useNavigate();
    const { language } = useContext(AppStateContext);

    const getText = (key) => {
        return translations[language][key] || key; // Default to the provided key if translation is not found
    };

    const treatments = [
        {
            key: 'zirconium',
            name: getText('zirconium.name'),
            description: getText('zirconium.description'),
            image: treatment1
        },
        {
            key: 'emax',
            name: getText('emax.name'),
            description: getText('emax.description'),
            image: treatment2
        },
        {
            key: 'porselen',
            name: getText('porselen.name'),
            description: getText('porselen.description'),
            image: treatment11
        },
        {
            key: 'lamine',
            name: getText('lamine.name'),
            description: getText('lamine.description'),
            image: treatment3
        },
        {
            key: 'implant',
            name: getText('implant.name'),
            description: getText('implant.description'),
            image: treatment4
        },
        {
            key: 'rootcanal',
            name: getText('rootcanal.name'),
            description: getText('rootcanal.description'),
            image: treatment5
        },
        {
            key: 'toothextraction',
            name: getText('toothextraction.name'),
            description: getText('toothextraction.description'),
            image: treatment6
        },
        {
            key: 'orthodontics',
            name: getText('orthodontics.name'),
            description: getText('orthodontics.description'),
            image: treatment7
        },
        {
            key: 'bleaching',
            name: getText('bleaching.name'),
            description: getText('bleaching.description'),
            image: treatment8
        },
        {
            key: 'scaling',
            name: getText('scaling.name'),
            description: getText('scaling.description'),
            image: treatment9
        },
        {
            key: 'periodontal',
            name: getText('periodontal.name'),
            description: getText('periodontal.description'),
            image: treatment12
        },
        {
            key: 'filling',
            name: getText('filling.name'),
            description: getText('filling.description'),
            image: treatment10
        },
    ];

    const handleNavigation = (path) => {
        window.scrollTo(0, 0);
        navigate(path);
    }

    return (
        <div className='grid md:grid-cols-2 lg:grid-cols-3 md:p-10 gap-5 pt-5'>
            {treatments.map((item, index) => (
                <div onClick={() => handleNavigation(`/treatment/${item.key}`)} key={index} className='pt-10 cursor-pointer rounded-xl shadow-lg hover:scale-105 duration-500 bg-white'>
                    <div className='flex flex-col w-full h-full items-center justify-center md:mb-10 relative'>
                        <img className='h-32 w-64 rounded-2xl object-cover' src={item.image} alt=''></img>
                        <div className='p-5 rounded-xl'>
                            <div className='text-2xl font-bold pt-2 px-2 text-[#0F969C]'>{getText(item.key).name}</div>
                            <div className='text-sm md:text-base pt-2 px-2'>{getText(item.key).description.slice(0, 200) + ' ...'}</div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default LogoSlider;
